<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0px;
  margin: 0px;
  background: #eee;
}
#app {
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  widows: 100%;
  height: 100%;
}
/* 全局样式 */
.app-container {
  margin: 100px;
}
/* 设置滚动条的宽度、颜色和背景 */
::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
}

/* 设置滚动条滑块的样式 */
::-webkit-scrollbar-thumb {
  background-color: #dddee0; /* 滑块颜色 */
  border-radius: 4px; /* 滑块圆角 */
}

/* 设置滚动条轨道的样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1; /* 轨道背景颜色 */
  border-radius: 4px; /* 轨道圆角 */
}

/* 将样式应用于滚动容器 */
.my-scroll-container {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue